export const ru = {
    'banner-required-href-turbo-vcard-organization':
        'Укажите ссылку на сайт, создайте Турбо-страницу, заполните виртуальную визитку или привяжите организацию Яндекс.Справочника',
    'organization-not-found': 'Выбранная организация не найдена в Я.Справочнике'
};
